// Publication review and requisition lifecycle are independent. A reviewed
// role is live only while open; closed roles keep their review/history.
export const REQUISITION_STATUSES = ['open', 'filled', 'expired', 'archived'];

export function requisitionStatusOf(listing) {
  return REQUISITION_STATUSES.includes(listing?.status) ? listing.status : 'open';
}

export function isOpenRequisition(listing) {
  return requisitionStatusOf(listing) === 'open';
}

export function isActiveListing(
  listing,
  reviewStatus = listing?.reviewStatus,
  status = requisitionStatusOf(listing),
) {
  return !!listing && !listing.deleted && status === 'open' && reviewStatus === 'reviewed';
}
